<template>
  <div class="news-detail-box">
    <!-- 消息详情 -->
    <div class="the-body-box">
      <el-breadcrumb separator=">" class="breadcrumb-box">
        <el-breadcrumb-item to="/">{{
          $t("IndexNavbar.HomePage")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item to="/latest-news">{{
          $t("IndexNavbar.LatestNews")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          $t("IndexNavbar.NewsDetail")
        }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="news-detail-content">
        <div class="news-title" v-if="$route.query.contentType">
          {{ titleArr[$route.query.titleType] }}
        </div>
        <div class="news-title" v-else>{{ newDetail.chTitle }}</div>
        <div class="text-light-gray">{{ newDetail.updateTime }}</div>
        <div class="text-item" v-if="$route.query.informationId">
          <img :src="newDetail.logoPath" alt="" />
        </div>
        <div class="text-item" v-html="newDetail.chContent"></div>
      </div>
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
export default {
  filters: {
    filtersTitle: function (value) {
      return arr[value];
    },
  },
  data() {
    return {
      titleArr: [
        "",
        this.$t("LastTranslate.ContactUs"),
        this.$t("LastTranslate.LegalNotices"),
        this.$t("LastTranslate.generalLaw"),
        this.$t("LastTranslate.QA"),
        this.$t("LastTranslate.Contact"),
      ],
      newDetail: [],
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  watch: {
    $route() {
      if (this.$route.query.informationId || this.$route.query.contentType) {
        this.getInformationById();
      }
      this.title = this.$route.query.title || "";
    },
  },
  mounted() {
    if (this.$route.query.informationId || this.$route.query.contentType) {
      this.getInformationById();
    }
  },
  methods: {
    getInformationById() {
      let params = {};
      if (this.$route.query.informationId) {
        params.informationId = this.$route.query.informationId;
      } else {
        params.contentType = this.$route.query.contentType;
      }
      this.$commonPromise("get", this.$Api.getInformationById, params).then(
        (res) => {
          if (res.code === 200) {
            this.newDetail = res.data;
          }
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.news-detail-box {
  padding: 64PX 0;
  border-top: 1PX solid #ddd;
  .breadcrumb-box {
    margin-bottom: 20PX;
  }
  .news-detail-content {
    padding: 40PX 74PX 40PX 40PX;
    border: 1PX solid #e6e6e6;
    .news-title {
      margin-bottom: 20PX;
      font-size: 24PX;
    }
    .text-item {
      line-height: 24PX;
      margin-top: 39PX;
    }
  }
}
</style>